import { render, staticRenderFns } from "./UsersListItem.vue?vue&type=template&id=b5a046b0&scoped=true&"
import script from "./UsersListItem.vue?vue&type=script&lang=js&"
export * from "./UsersListItem.vue?vue&type=script&lang=js&"
import style0 from "./UsersListItem.vue?vue&type=style&index=0&id=b5a046b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a046b0",
  null
  
)

export default component.exports